import { inject, observer } from "mobx-react";
import React from "react";
import SearchClauseForm from "../components/SearchClauseForm";
import Clause from "../models/Clause";
import SearchOptionMenu from "../components/SearchOptionMenu";
import AdvancedSearchMenu from "../components/AdvancedSearchMenu";
import Button from "@material-ui/core/Button";
import MatchupsDialog from "../components/MatchupsDialog";

class PlayFilters extends React.Component {
  handleSearch() {
    const { basicSearchStore, routerStore, videoSearchStore } = this.props;

    videoSearchStore.resetPagination();
    if (!basicSearchStore.isValid()) {
      return;
    }

    routerStore.history.push({
      pathname: routerStore.location.pathname,
      search: `q=${basicSearchStore.pitsQuery}&fp=${videoSearchStore.feedPreference}`
    });
  }

  render() {
    const { basicSearchStore, matchupsDialogStore } = this.props;
    return (
      <div style={{ display: "flex" }}>
        {basicSearchStore.clauses.map((c, i) => (
          <SearchClauseForm
            canDelete={i !== 0}
            clause={c}
            clauseIdx={i}
            label={c.asString}
            key={`search-clause-${i}`}
            onSave={clause => {
              this.handleSearch();
            }}
            onDelete={clauseIdx => {
              basicSearchStore.removeClause(clauseIdx);
              this.handleSearch();
            }}
          />
        ))}
        <SearchClauseForm
          canDelete={false}
          clause={new Clause()}
          label={"Add Filter"}
          onSave={clause => {
            basicSearchStore.addClause(clause);
            this.handleSearch();
          }}
        />
        <Button
          color="primary"
          size="small"
          onClick={() => {
            matchupsDialogStore.open();
            this.setState({ query: "" });
          }}
        >
          Today&apos;s Matchups
        </Button>
        <SearchOptionMenu
          onSave={() => {
            this.handleSearch();
          }}
        />
        <AdvancedSearchMenu
          onSave={() => {
            this.handleSearch();
          }}
        />
        <MatchupsDialog />
      </div>
    );
  }
}

export default inject(
  "basicSearchStore",
  "routerStore",
  "videoSearchStore",
  "matchupsDialogStore"
)(observer(PlayFilters));



// WEBPACK FOOTER //
// ./src/containers/PlayFilters.js